import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from './styled';

const StatusPill = ({
  isOnline,
  className
}) => {
  const value = isOnline ? 'online' : 'offline';
  const label = isOnline ? 'Online' : 'Offline';

  return (
    <Wrapper className={ className } value={ value }>
      {label}
    </Wrapper>
  );
};

StatusPill.propTypes = {
  isOnline: PropTypes.bool,
  className: PropTypes.string
};

StatusPill.defaultProps = {
  isOnline: false,
  className: ''
};

export default StatusPill;
